export class AzureRestorePointDisk {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "lun",
            "baseName": "lun",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureRestorePointDisk.attributeTypeMap;
    }
    constructor() {
    }
}
